/* Norsk (bokmål) — eierflater. Nøklene speiler en.js; alt som mangler faller tilbake til engelsk. */
export const nb = {
  "brand.powered_by": "Levert av DigiHome",
  "common.back": "Tilbake",
  "common.continue": "Fortsett",
  "common.cancel": "Avbryt",
  "common.close": "Lukk",
  "common.per_year": "per år",
  "common.version": "Versjon {n}",

  "price.of_revenue": "av bookinginntekten",
  "price.per_stay": "/ opphold",
  "price.per_guest": "/ gjest",
  "price.per_night": "/ natt",
  "price.monthly": "/ måned",
  "price.per_month": "/ måned",
  "price.one_time": "engangs",

  "chip.required": "Fast",
  "chip.included": "Inkludert",
  "chip.optional": "Valgfritt",
  "chip.recommended": "Anbefalt",

  "ptype.apartment": "Leilighet",
  "ptype.house": "Enebolig",
  "ptype.cabin": "Hytte",
  "ptype.other": "Annet",

  "customer.attn": "att. {name}",

  "tax.incl_short": "inkl. {label}",
  "tax.excl_short": "ekskl. {label}",
  "tax.no_tax_short": "uten avgift",
  "tax.note_incl": "Alle honorarer er inkludert {rate} % {label}.",
  "tax.note_excl": "Alle honorarer er oppgitt uten {label}. {rate} % {label} kommer i tillegg på faktura.",
  "tax.note_reverse": "Ingen {label} beregnes — omvendt avgiftsplikt; eier gjør opp avgift i eget land.",
  "tax.note_none": "Det legges ikke avgift på disse honorarene.",

  "preview.inert": "Dette er en forhåndsvisning — ingenting sendes eller lagres.",
  "sign.signed_sub": "Velkommen til {org}. Nå gjør vi {property} klar.",

  "owner_offer.doc_label": "Forslag",
  "owner_offer.title": "Vårt forslag for {property}",
  "owner_offer.prepared_for": "Utarbeidet for {name}",
  "owner_offer.prepared_by": "Utarbeidet av",
  "owner_offer.reply_to": "Svar til {email}",
  "owner_offer.sent_on": "Sendt {date}",
  "owner_offer.valid_until": "Gyldig til {date}",
  "owner_offer.valid_row": "Gyldig til",
  "owner_offer.version": "Versjon {n}",
  "owner_offer.your_property": "boligen din",
  "owner_offer.meta_bedroom_one": "1 soverom",
  "owner_offer.meta_bedrooms": "{n} soverom",
  "owner_offer.meta_guests": "inntil {n} gjester",
  "owner_offer.existing_one": "Du har allerede ett hjem hos {org} ({names}). Takk for at du stoler på oss med enda ett.",
  "owner_offer.existing_many": "Du har allerede {n} hjem hos {org} ({names}). Takk for at du stoler på oss med enda ett.",

  "owner_offer.money_title": "Slik blir økonomien",
  "owner_offer.net_title": "Estimert til deg, år 1",
  "owner_offer.net_sub": "Det som blir igjen til deg etter vårt honorar og engangskostnader, basert på {revenue} i bookinginntekt. Bytt scenario for å se hvordan sesongen påvirker tallet.",
  "owner_offer.scenario_label": "Inntektsscenario",
  "owner_offer.scenario.low": "Forsiktig",
  "owner_offer.scenario.mid": "Forventet",
  "owner_offer.scenario.high": "Sterk",
  "owner_offer.you_keep": "Du beholder",
  "owner_offer.fee_short": "Vårt honorar",
  "owner_offer.fee_share": "Forvaltningshonorar",
  "owner_offer.est_fee_short": "Vårt honorar, år 1",
  "owner_offer.revenue_row": "Estimert bookinginntekt",
  "owner_offer.range_note": "Spenn {min} – {max}",
  "owner_offer.fee_row": "Vårt honorar · {pct}",
  "owner_offer.one_time": "Engangskostnader",
  "owner_offer.monthly": "Månedlige kostnader",
  "owner_offer.net_row": "Til deg, år 1",
  "owner_offer.variable": "Kostnader per opphold / gjest",
  "owner_offer.variable_note": "Dekkes normalt av gjesten.",
  "owner_offer.estimate_note": "Estimatet bygger på sammenlignbare boliger og markedsdata — ikke en garanti.",
  "owner_offer.estimate_source": "Kilde: {source}",
  "owner_offer.cost_title": "Hva det koster",
  "owner_offer.no_estimate_sub": "Dette forslaget inneholder ikke et inntektsestimat — honoraret og de faste kostnadene under er det du betaler. Inntekten avhenger av sesongen og hvor ofte boligen er tilgjengelig.",
  "owner_offer.own_title": "Prøv ditt eget tall — hvis boligen tjener",
  "owner_offer.own_note": "Din antakelse, ikke et estimat fra oss. Dra for å se hvordan fordelingen endrer seg.",

  "owner_offer.plan_title": "Planen",
  "owner_offer.no_plan_items": "Det er ikke satt et forvaltningshonorar i dette forslaget.",
  "owner_offer.included_title": "Inkludert i planen",
  "owner_offer.optional_title": "Valgfrie tillegg",
  "owner_offer.extras_sub": "Slå på det du ønsker — tallene oppdateres etter hvert som du velger.",
  "owner_offer.extras_row": "Tillegg",
  "owner_offer.selected_extras": "{n} tillegg valgt",
  "owner_offer.selected_extra_one": "1 tillegg valgt",
  "owner_offer.no_extras": "Ingen tillegg valgt",

  "owner_offer.portfolio_title": "Hjem vi allerede drifter",
  "owner_offer.portfolio_sub": "{n} hjem under forvaltning{cities}",
  "owner_offer.portfolio_sub_one": "1 hjem under forvaltning{cities}",
  "owner_offer.portfolio_in": " i {cities}",
  "owner_offer.cover_illustrative": "Illustrasjonsfoto",

  "owner_offer.what_changed": "Hva som er endret siden versjon {n}",
  "owner_offer.change.item_added": "{name} lagt til ({price})",
  "owner_offer.change.item_removed": "{name} fjernet",
  "owner_offer.change.item_amount": "{name}: {from} → {to}",
  "owner_offer.change.estimate": "Inntektsestimat: {from} → {to}",
  "owner_offer.change.valid_until": "Nå gyldig til {date}",
  "owner_offer.change.intro": "Innledningen ble oppdatert",
  "owner_offer.change.terms": "Vilkårene ble oppdatert",
  "owner_offer.change.highlights": "Høydepunktene ble oppdatert",

  "owner_offer.next_title": "Veien videre",
  "owner_offer.next.accept": "Du godtar forslaget",
  "owner_offer.next.sign": "Signer avtalen digitalt — under ett minutt",
  "owner_offer.next.onboard": "En guidet gjennomgang mens du går gjennom boligen",
  "owner_offer.next.live": "{org} gjør boligen klar og legger den ut",
  "owner_offer.trust_sign": "Signer digitalt på telefonen",
  "owner_offer.trust_private": "Lenken er laget kun for deg",
  "owner_offer.trust_edit": "Endre tillegg når som helst før du godtar",

  "owner_offer.terms": "Godt å vite",
  "owner_offer.questions": "Spørsmål? Svar på e-posten fra {org}.",
  "owner_offer.questions_email": "Spørsmål? Skriv til",
  "owner_offer.questions_reads": "{name} leser hver melding.",

  "owner_offer.accept": "Godta og fortsett",
  "owner_offer.decline": "Ikke for meg",
  "owner_offer.go_sign": "Se og signer avtalen",
  "owner_offer.sticky_line": "År 1 netto · {pct} honorar",
  "owner_offer.decline_title": "Ikke riktig for deg?",
  "owner_offer.decline_sub": "Gi {org} beskjed — helt uproblematisk.",
  "owner_offer.decline_reason": "Er det noe vi kunne gjort annerledes? (valgfritt)",
  "owner_offer.declined_title": "Takk for beskjeden",
  "owner_offer.declined_sub": "Vi har informert {org}. Du er velkommen til å ta kontakt når som helst.",
  "owner_offer.contact_us": "Skriv til {email}",
  "owner_offer.invalid": "Denne lenken er ikke gyldig eller har utløpt.",
  "owner_offer.invalid_title": "Denne lenken virker ikke",
  "owner_offer.preview_badge": "Forhåndsvisning",
  "owner_offer.status_accepted": "Godtatt",
  "owner_offer.expired_chip": "Utløpt",
  "owner_offer.superseded_chip": "Nyere versjon sendt",
  "owner_offer.superseded": "En nyere versjon av dette forslaget er sendt til deg.",
  "owner_offer.superseded_sub": "Se i innboksen etter siste versjon — denne kan ikke lenger godtas.",
  "owner_offer.expired_title": "Dette forslaget utløp {date}",
  "owner_offer.expired_sub": "Be {org} om et oppdatert forslag — det tar et minutt, og du får en ny lenke på e-post.",
  "owner_offer.request_update": "Be om et oppdatert forslag",
  "owner_offer.update_requested": "Forespørsel sendt — {org} tar kontakt snart.",
  "owner_offer.accepted_banner": "Du godtok dette forslaget {date}",
  "owner_offer.accepted_next": "Neste: se gjennom og signer avtalen — det tar under ett minutt på telefonen.",
};
